<template>
  <b-card class="col pl-2 pr-2 ">

    <b-card-body>
      <b-card-text>
        <b-container>
          <b-row class="card-title">
            <b-col><b>Time:</b> {{ time_chunk['time'] }}</b-col>
            <b-col><b>Target:</b> {{ target }}</b-col>

            <b-col><b>Beam:</b> {{ time_chunk['beam'] }}</b-col>
            <div class="h3">

              <b-icon-arrow-bar-up v-if="toggle" @mousedown="toggleContentVisibility"></b-icon-arrow-bar-up>
              <b-icon-arrow-bar-down v-if="!toggle" @mousedown="toggleContentVisibility"></b-icon-arrow-bar-down>
            </div>
          </b-row>
          <b-row>
            <b-col>
              <b-img-lazy fluid v-bind:src="imageSrc"></b-img-lazy>
            </b-col>
          </b-row>
          <b-row v-if="toggle">
            <b-container class="mt-2">
              <b-row v-for="[attr, value] of Object.entries(this.time_chunk)" v-bind:key="attr">
                <b-col>
                  <b>{{ attr }}</b>
                </b-col>
                <b-col v-if="!['png', 'fits'].includes(attr)">
                  {{ value }}

                </b-col>
                <b-col v-if="['png', 'fits'].includes(attr)">
                  <a v-bind:href="toUrl(value)">link</a>
                </b-col>
              </b-row>
            </b-container>
          </b-row>

        </b-container>

      </b-card-text>
    </b-card-body>
  </b-card>
</template>

<script>

export default {
  name: "ProductsView",
  data() {
    return {
      toggle: false
    }
  },
  props: ['time_chunk', 'title', 'sap'],
  computed: {
    imageSrc() {
      return this.toUrl(this.time_chunk['png'])
    },
    target() {
      if (this.time_chunk['target'] !== undefined) {
        return this.time_chunk['target']
      } else {
        let hour =Number(this.time_chunk['time'].split(':')[0])
        if(hour < 3 || hour > 18) {
          return 'Calibrator'

        }
        return this.sap === 0 ? 'SUN' : 'Calibrator'
      }
    }

  },
  methods: {
    toggleContentVisibility() {
      this.toggle = !this.toggle;
    },
    toUrl(path) {
      return path.replace('/spaceweather/', 'https://spaceweather.astron.nl/')

    }
  }
}
</script>

<style scoped>
.card-title {

}
</style>